module.exports = __webpack_public_path__ + "img/rang2.effe1dd9.png";